import * as React from 'react'

const PromptContext = React.createContext<
  undefined | [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>(undefined)

const usePromptContext = () => {
  const promptStateAction = React.useContext(PromptContext)

  if (!promptStateAction) throw 'PrompContext state is missing'

  return promptStateAction
}

type PromptProps = {
  children: React.ReactNode
}
const PromptProvider = ({ children }: PromptProps) => {
  const promptStateAndAction = React.useState<boolean>(false)

  return <PromptContext.Provider value={promptStateAndAction}>{children}</PromptContext.Provider>
}

export { PromptProvider, usePromptContext }
